import React from 'react';
import { Link } from 'react-router-dom';
import ReactDOM from 'react-dom';
import jQuery from 'jquery';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactLoading from 'react-loading';
import {
    Modal,
    
} from 'react-bootstrap';
import classNames from 'classnames';
import * as SVGICONS from '../../images/img/images';
import * as signinActions from '../../actions/signinActions';
import validator from './validator';
const autoBind = require('auto-bind');

//login container component
class ActivateAccount extends React.Component {
	constructor(props, context) {
		super(props, context);
		autoBind(this);
		console.log('props in accountActivation', this.props)
		this.state = {
			email: { value: '', isValid: true, message: '' },
			isActivated: true,
			isLoading: true
		};
		//binding current context to all functions
		// this.onForgotHandler = this.onForgotHandler.bind(this);


	}
	componentWillMount() {
		let obj = {
			activationKey: this.props.activationKey
		}
		this.props.actions.activateAccount(obj)
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.activateData.success) {
			this.setState({ isActivated: true, isLoading: false })
		} else {
			this.setState({ isActivated: false, isLoading: false })
		}
	}

	render() {
		var { email } = this.state;
		var emailGroupClass = classNames('input-group', { 'has-error': !email.isValid });
		return (
			<Modal show={this.props.activateModalOpen} size="modal-sm" onHide={(e)=> this.props.closeActive(e)}>
				{this.state.isLoading ? <div className="loaderCenter"><ReactLoading type={'bars'} color={'blue'} /></div> :
					<div>
						<Modal.Header>
							{/* <ModalClose onClick={this.props.closeActive} /> */}
							{/* <ModalTitle><img src={require('../../images/images/logo.svg')} alt="" /></ModalTitle> */}
							<img src={require('../../images/images/logo.svg')} alt="" />
						</Modal.Header>
						<Modal.Body>
							{/* <ToastContainer /> */}
							<form className="signup-form" id="loginForm">
								<div className="signIn changePass">{this.state.isActivated ? 'Account Activated' : ''}</div>
								<p style={{ "textAlign": "center" }}>{this.state.isActivated ? 'Your account has been activated successfully, You may login to your account now' : 'Your Link Has Expired'} </p>

								<div className="loginInput">
									<div className="btngrouplogIn ">
										<Link  href="#" onClick={this.props.closeActivateOpenSigin} className="forgetPass"> Go to Sign In</Link>
									</div>
								</div>
							</form>
						</Modal.Body>
						<Modal.Footer>
						</Modal.Footer>
					</div>
				}
			</Modal >


		);
	}
}
{/* //this tells what state should expose on props  */ }
function mapStateToProps(state, ownProps) {
	return {
		activateData: state.signin.activateData
	};
}

// bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(signinActions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(ActivateAccount);
// export default (Signup);
